import styled from '@emotion/styled/macro';
import { Variables } from '../base';

/** Seven KPI tiles in one row; they wrap rather than shrink below a readable width. */
export const FinancialCardsRow = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(112px, 1fr));
    gap: 10px;
`;

export const FinancialCard = styled.div<{ $highlighted?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    padding: 12px 14px;
    border: 1px solid
        ${({ $highlighted }) => ($highlighted ? Variables.ThemeLight.PrimaryMedium1 : Variables.ThemeLight.Border2)};
    background: ${({ $highlighted }) =>
        $highlighted ? Variables.ThemeLight.PrimaryMild2 : Variables.ThemeLight.Background2};
    border-radius: 8px;
`;

export const FinancialCardTitle = styled.div<{ $highlighted?: boolean }>`
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${({ $highlighted }) =>
        $highlighted ? Variables.ThemeLight.PrimaryInverted3 : Variables.ThemeLight.TextMild};
`;

export const FinancialCardValue = styled.div<{ $isZero?: boolean }>`
    font-family: ${Variables.Fonts.calibre};
    font-size: 19px;
    font-weight: 600;
    line-height: 1;
    font-variant-numeric: tabular-nums;
    color: ${({ $isZero }) => ($isZero ? Variables.ThemeLight.TextXMild : Variables.ThemeLight.TextStrong)};
`;
